import React from 'react';
import PropTypes from 'prop-types';

const HighlightOverlay = props => {
  const { clearHighlight, fieldName } = props;

  return (
    <div className="highlight-overlay">
      <div
        className="dismiss"
        role="button"
        onClick={() => {
          clearHighlight(fieldName);
        }}
      >
        <i className="zmdi zmdi-arrow-left-bottom" />
      </div>
    </div>
  );
};

HighlightOverlay.propTypes = {
  clearHighlight: PropTypes.func.isRequired,
  fieldName: PropTypes.string,
};

export default HighlightOverlay;
